import { render, staticRenderFns } from "./RegisterTableStateNotice.vue?vue&type=template&id=4e995244&scoped=true"
import script from "./RegisterTableStateNotice.vue?vue&type=script&lang=js"
export * from "./RegisterTableStateNotice.vue?vue&type=script&lang=js"
import style0 from "./RegisterTableStateNotice.vue?vue&type=style&index=0&id=4e995244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e995244",
  null
  
)

export default component.exports